import { Alert, Checkbox, Modal, Space, Typography } from "antd";

export default function LastOpeningFilledModal({
  isLastOpeningModalVisible,
  setIsLastOpeningModalVisible,
  statusForm,
  loading = false,
}) {
  const handleCancel = () => {
    setIsLastOpeningModalVisible((prev) => ({
      ...prev,
      showModal: false,
      movingCandidate: false,
    }));
  };

  const handleOk = () => {
    statusForm.submit();
  };

  return (
    <Modal
      open={isLastOpeningModalVisible.showModal}
      centered
      okText="Submit"
      title="Final Job Opening Filled"
      className="s2-theme-style modal-overflow-auto"
      onCancel={handleCancel}
      onOk={handleOk}
      okButtonProps={{ loading }}
      width={600}
      bodyStyle={{ overflow: "hidden" }}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Alert
          type="warning"
          description={
            <>
              <Typography.Paragraph>
                All candidates must be in a final status when a job is filled or
                closed. Check this box to auto-update remaining candidates to
                <Typography.Text strong>
                  {" "}
                  "Declined – Requisition Closed"
                </Typography.Text>
                , or plan to complete this step manually.
              </Typography.Paragraph>

              <div
                style={{
                  background: "rgba(0, 0, 0, 0.02)",
                  padding: "8px 12px",
                  borderRadius: 4,
                  borderLeft: "3px solid #faad14",
                  marginTop: 12,
                }}
              >
                <Typography.Paragraph style={{ marginBottom: 0 }}>
                  <Typography.Text strong>
                    Remaining candidates not in final status:
                  </Typography.Text>{" "}
                  {isLastOpeningModalVisible.activeCandidateCount}
                </Typography.Paragraph>
              </div>
            </>
          }
          showIcon
        />

        <Checkbox
          onChange={(e) => {
            setIsLastOpeningModalVisible((prev) => ({
              ...prev,
              movingCandidate: e.target.checked,
            }));
          }}
          checked={isLastOpeningModalVisible.movingCandidate}
        >
          Move all active candidates to Declined - Requisitions Closed
        </Checkbox>
      </Space>
    </Modal>
  );
}
